import { fabric } from "fabric";

export default async function shape(obj) {
  // Load the SVG string and create the Fabric object
  const object = await new Promise((resolve, reject) => {
    fabric.loadSVGFromString(obj.svg, (objects, options) => {
      if (!objects || objects.length === 0) {
        reject(new Error('Failed to load SVG string.'));
      } else {
        const svgObject = fabric.util.groupSVGElements(objects, options);
        resolve(svgObject);
      }
    });
  });

  // Set the object properties
  // @TODO: remove this from here, move to composable
  object.objectType = obj.objectType;
  object.id = obj.id;

  if(object.objectType === 'line') {
    const controlsVisibilitySettings = {
      tl: false,
      tr: false,
      bl: false,
      br: false,
      mt: false,
      mb: true,
      ml: true,
      mr: true,
      mtr: true
    }
    object.setControlsVisibility(controlsVisibilitySettings);
  }

  return object;
}
